import { Comment } from 'semantic-ui-react';

export default Comment;
